const LeftPanel = () => {
    return  (
        <div className="auth-panel-left" aria-hidden="true">
            <div className="auth-orb auth-orb-1" />
            <div className="auth-orb auth-orb-2" />
            <div className="auth-orb auth-orb-3" />
            <div className="auth-grid" />

            <div className="auth-panel-left__content">
                <div className="auth-badge">
                    <span className="auth-badge__dot" />
                    Rede social brasileira
                </div>
                <h2 className="auth-panel-left__headline">
                    Conecte-se com<br />
                    <span>quem você ama</span>
                </h2>
                <p className="auth-panel-left__sub">
                    Compartilhe momentos, faça amizades e descubra conteúdos que combinam com você.
                </p>
                <div className="auth-dots">
                    <span className="auth-dots__dot auth-dots__dot--active" />
                    <span className="auth-dots__dot" />
                    <span className="auth-dots__dot" />
                </div>
            </div>
        </div>
    )
}

export default LeftPanel;